import React from "react";
import { Route } from "react-router-dom";
import PurchaseOrder from "../../../containers/modules/purchasing/purchase-order";
import AccessControl from "../../../components/utilities/Class/AccessControl";

export default function PurchaseOrderRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="purchase-order"
      index
      element={
        <AccessControl
          name={"Purchase Order List"}
          auth={authUser}
          component={() => <PurchaseOrder />}
        />
      }
    ></Route>
  );
}
